import React, { MouseEvent, useCallback } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useState } from "react";
import { ComponentStyles } from "../../models/app";
import { blockConfigs, starterBlocks } from "../../models/block";
import { PaletteItem } from "./PaletteItem";
import { useDispatch } from "react-redux";
import { addBlock } from "../../store/game/gameSlice";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { BlockTypes } from "../../models/block-types";

const styles: ComponentStyles = {
  container: {
    position: "absolute",
    top: "90px",
    left: "0px",
    height: "70vh",
    minWidth: "70px",
    display: "flex",
    flexDirection: "row",
    transition: "left 0.5s",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "white",
    height: "100%",
    padding: "20px 5px",
    overflowY: "auto",
  },
  slideButtonContainer: {
    backgroundColor: "#595A59",
    borderBottomRightRadius: "10px",
    borderTopRightRadius: "10px",
    background: "white",
    width: "20px",
    height: "20px",
    padding: "5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export const Palette: React.FC = () => {
  const classes = styles;
  const dispatch = useDispatch();
  const [blockOptions] = useState(starterBlocks);
  const [isExpanded, setIsExpanded] = useState(true);

  const leftPos = isExpanded ? "0px" : "-80px";

  const handleBlockAdd = (
    e: MouseEvent<HTMLButtonElement | HTMLDivElement>,
    blockType: BlockTypes
  ) => {
    e.stopPropagation();
    const blockConfig = blockConfigs[blockType];
    if (!blockConfig) return;
    const { inputCapacity, processingCapacity } = blockConfig;
    dispatch(
      addBlock({
        top: 100,
        left: 100,
        id: "temp",
        width: 100,
        height: 100,
        blockType,
        inputCapacity,
        processingCapacity,
      })
    );
  };

  const handleExpandedToggle = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  return (
    <Box style={{ ...classes.container, left: leftPos }}>
      <Card style={classes.card} elevation={10}>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "10px",

          }}
        >
          {blockOptions.map((block) => (
            <PaletteItem
              blockType={block}
              onItemClick={handleBlockAdd}
              key={block}
            />
          ))}
        </Box>
      </Card>
      <Box
        style={classes.slideButtonContainer}
        onClick={() => handleExpandedToggle()}
      >
        {isExpanded && (
          <ArrowCircleLeftIcon
            sx={{
              color: "#595A59",
              cursor: "pointer",
              "&:hover": {
                color: "#000",
              },
            }}
          />
        )}
        {!isExpanded && (
          <ArrowCircleRightIcon
            sx={{
              color: "#595A59",
              cursor: "pointer",
              "&:hover": {
                color: "#000",
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
};
